import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import './mops-pain-scale-controller.css';
import { Endpoint } from '../../../constants/endpoints';
import { FragmentNames, MopsPainScaleAliases } from '../../../codegen';

@Controller({ fragment: FragmentNames.MOPS_PAIN_SCALE })
class MopsPainScaleController extends BaseController {

  @Inject(MopsPainScaleAliases.REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(MopsPainScaleAliases.CRYING_RADIO_GROUP)
  cryingRadioGroupApi!: RadioGroupAPI;

  @Inject(MopsPainScaleAliases.POSTURE_RADIO_GROUP)
  postureRadioGroupApi!: RadioGroupAPI;

  @Inject(MopsPainScaleAliases.TRANSACTION_RADIO_GROUP)
  transactionRadioGroupApi!: RadioGroupAPI;

  @Inject(MopsPainScaleAliases.VERBAL_RADIO_GROUP)
  verbalRadioGroupApi!: RadioGroupAPI;

  @Inject(MopsPainScaleAliases.AGITATION_RADIO_GROUP)
  agitationRadioGroupApi!: RadioGroupAPI;

  @OnMount({ target: MopsPainScaleAliases.CRYING_RADIO_GROUP})
  onMountCryingnForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.mopsPainScaleRadioGroup(335955, radioGroup);
  }

  @OnMount({ target: MopsPainScaleAliases.POSTURE_RADIO_GROUP})
  onMountPostureForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.mopsPainScaleRadioGroup(335958, radioGroup);
  }

  @OnMount({ target: MopsPainScaleAliases.TRANSACTION_RADIO_GROUP})
  onMountTransactionForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.mopsPainScaleRadioGroup(335956, radioGroup);
  }

  @OnMount({ target: MopsPainScaleAliases.VERBAL_RADIO_GROUP})
  onMountVerbalForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.mopsPainScaleRadioGroup(335959, radioGroup);
  }

  @OnMount({ target: MopsPainScaleAliases.AGITATION_RADIO_GROUP})
  onMountAgitationForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.mopsPainScaleRadioGroup(335957, radioGroup);
  }

  @OnClose({ target: MopsPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE})
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: MopsPainScaleAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: MopsPainScaleAliases.CRYING_FORM})
  onClickCancel(): void {
    ModalService.close(FragmentNames.MOPS_PAIN_SCALE);
  }

  @OnBeforeSubmit({ target: MopsPainScaleAliases.CRYING_FORM})
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.cryingRadioGroupApi?.getValue()?.value)
                   + (Number(this.postureRadioGroupApi?.getValue()?.value))
                   + (Number(this.transactionRadioGroupApi?.getValue()?.value))
                   + (Number(this.verbalRadioGroupApi?.getValue()?.value))
                   + (Number(this.agitationRadioGroupApi?.getValue()?.value)));
    ModalService.close(FragmentNames.MOPS_PAIN_SCALE);
  }

  mopsPainScaleRadioGroup(expressionId:number, radioGroup:RadioGroupAPI) :void{
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }
}
export default MopsPainScaleController;
